import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SkeletonServiceService } from 'src/services/skeleton/skeleton.service';

@Injectable({
  providedIn: 'root',
})
export class MobileScreenGuard implements CanActivate {
  constructor(private skeletonService: SkeletonServiceService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    var allowed: boolean = this.skeletonService.isMobile();
    if (!allowed) {
      return this.router.createUrlTree(['/']);
    }
    return allowed;
  }
}
